
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MinhaContaDialog from "@/components/dialogs/administrativo/usuarios/MinhaContaDialog.vue";

const Auth = namespace("Auth");

@Component({
  name: "HeaderUserInfoDropdown",
  components: { MinhaContaDialog },
})
export default class HeaderUserInfoDropdown extends Vue {
  @Auth.Getter
  private isLoggedIn!: boolean;

  @Auth.Getter
  private userData!: any;

  @Auth.Action
  private signOut!: (message?: string) => Promise<any>;

  get mobileViewport() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get nameInitials() {
    return this.userData.nome
      .match(/(^\S\S?|\b\S)?/g)
      .join("")
      .match(/(^\S|\S$)?/g)
      .join("")
      .toUpperCase();
  }

  onMinhaContaClick() {
    if (this.isLoggedIn) {
      this.showEditUserDialog();
    } else {
      this.$router.push("/login");
    }
  }

  onMeusPedidosClick() {
    if (this.isLoggedIn && this.$router.currentRoute.path !== "/pedidos") {
      this.$router.push("/pedidos");
    }
  }

  onFinanceiroClick() {
    if (this.isLoggedIn && this.$router.currentRoute.path !== "/financeiro") {
      this.$router.push("/financeiro");
    }
  }

  showEditUserDialog() {
    const userDlg = this.$refs.userDlg as MinhaContaDialog;
    //quando o dropdown fecha, se o diálogo tá aberto ele fecha tmb
    setTimeout(() => {
      userDlg.show();
    }, 300);
  }

  efetuarLogoff() {
    this.signOut().then(() => {
      if (this.$route.name == "Home") {
        this.$router.go(0);
      } else {
        this.$router.push("/home");
      }
    });
  }
}
